import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { ConfirmDialog } from "./common";
import { fmtDate } from "../lib/format";

const describe = (a) => `${a.resource_name} · ${a.site_name} · ${fmtDate(a.start_date)} → ${fmtDate(a.end_date)}`;

export function useAssignmentDelete(onDone) {
  const [target, setTarget] = useState(null);
  const confirm = async () => {
    try {
      await api.delete(`/assignments/${target.id}`);
      toast.success("✓ Assegnazione cancellata");
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    }
    setTarget(null);
  };
  const dialog = (
    <ConfirmDialog open={!!target} onOpenChange={() => setTarget(null)} title="Cancellare l'assegnazione al cantiere?"
      description={target ? describe(target) : undefined} onConfirm={confirm} confirmLabel="Cancella" />
  );
  return { ask: setTarget, dialog };
}
